var SDK_VERSION = '7.74.1';
export { SDK_VERSION };